/** @typedef {import('./types.js').MenuStyleProperties} MenuStyleProperties */

const {defaultMenuKeys} = require('./constants')

/**
 * @param {MenuStyleProperties} stylesProps
 * @param {Object} componentProps
 * */

const alignmentMapper = {
    'flex-start': 'start',
    'flex-end': 'end',
    center: 'center',
    justify: 'justify'
}

const migrateMenuLayout = (stylesProps, componentProps) => {
    addDefaultValues(stylesProps)
    migrateOverflow(stylesProps, componentProps)
    migratePadding(stylesProps)
    migrateSpacing(stylesProps)
    migrateJustification(stylesProps)
    migrateDirection(stylesProps)
}

/**
 * @param {MenuStyleProperties} currentBreakpointStylesProperties
 * @param {Object} componentProps
 */
const migrateOverflow = (currentBreakpointStylesProperties, componentProps) => {
    currentBreakpointStylesProperties.overflow = componentProps.menuMode === 'wrap' ? 'wrap' : 'scroll'
}

/**
 * @param {MenuStyleProperties} currentBreakpointStylesProperties
 * */
const migratePadding = currentBreakpointStylesProperties => {
    currentBreakpointStylesProperties['item-vertical-padding'] =
        currentBreakpointStylesProperties['item-padding-top'] || '0px'
    currentBreakpointStylesProperties['item-horizontal-padding'] =
        currentBreakpointStylesProperties['item-padding-right'] || '0px'
}

/**
 * @param {MenuStyleProperties} styles
 * */
const migrateSpacing = styles => {
    // in Stylable Horizontal Menu the spacing between items is the same as the margin between items
    // in Stylable Horizontal Menu layout panel, when you set spacing=x, it sets margin-left and margin-right to x/2
    const getSpacing = marginProperty => {
        const {value, unit} = parseValueWithUnit(styles[marginProperty])
        return `${value * 2}${unit}`
    }

    styles['menu-items-main-axis-gap'] = getSpacing('item-margin-left')
    styles['menu-items-cross-axis-gap'] = getSpacing('item-margin-top')
}

const migrateDirection = currentBreakpointStylesProperties => {
    currentBreakpointStylesProperties['container-direction'] =
        currentBreakpointStylesProperties['menu-direction'] || 'ltr'
}

const migrateJustification = currentBreakpointStylesProperties => {
    const menuFlexGrow = currentBreakpointStylesProperties['menu-flex-grow'] || '0'
    const isFlexGrowOne = menuFlexGrow === '1'

    if (isFlexGrowOne) {
        currentBreakpointStylesProperties['menu-items-justification'] = alignmentMapper.justify
        currentBreakpointStylesProperties['container-align'] = alignmentMapper.justify
    } else {
        currentBreakpointStylesProperties['menu-items-justification'] = 'none'
        currentBreakpointStylesProperties['container-align'] =
            alignmentMapper[currentBreakpointStylesProperties['menu-justify-content'] || 'center']
    }
}

const parseValueWithUnit = valueWithUnit => {
    const numericValue = parseFloat(valueWithUnit)
    const unit = extractUnit(valueWithUnit)

    return {
        value: numericValue,
        unit: unit || 'px'
    }
}

const extractUnit = valueWithUnit => {
    const DECIMALS_REGEX = /-?\d+(\.\d+)?/
    const FALLBACK_UNIT = 'px'
    return valueWithUnit.replace(DECIMALS_REGEX, '') || FALLBACK_UNIT
}

/**
 * @param {MenuStyleProperties} currentBreakpointStylesProperties
 * */
const addDefaultValues = currentBreakpointStylesProperties => {
    Object.entries(defaultMenuKeys).forEach(([key, value]) => {
        if (!currentBreakpointStylesProperties[key]) currentBreakpointStylesProperties[key] = value
    })
    currentBreakpointStylesProperties['horizontal-item-icon-display'] = 'none'
    currentBreakpointStylesProperties.addDividers = false
    currentBreakpointStylesProperties.spacingBetweenLabelAndDropdownIcon = '0px'
    currentBreakpointStylesProperties.orientation = 'horizontal'
}

module.exports = {
    migrateMenuLayout
}
